<button
  class="btn btn-primary"
  type="button"
  [disabled]="disabled"
  [attr.ngbAutofocus]="autoFocus ? '' : undefined"
  (click)="click($event)">
  @if (leftIconSrc) {
    <img [src]="leftIconSrc" [alt]="leftIconAlt" height="16" width="16" />
  }
  <ng-content></ng-content>
  @if (rightIconSrc) {
    <img [src]="rightIconSrc" [alt]="rightIconAlt" height="16" width="16" />
  }
</button>
